module.exports = __webpack_public_path__ + "static/media/0_2019_05_26-2.67375230.jpg";